import React from 'react';
import MaterialDetail from './MaterialDetail';

export default function MaterialDetailModal({ material, onClose }) {
  if (!material) return null;

  return (
    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Szczegóły: {material.name}</h5>
            <button type="button" className="btn-close" aria-label="Zamknij" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <MaterialDetail material={material} />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Zamknij</button>
            <button type="button" className="btn btn-primary" onClick={() => window.print()}>Drukuj</button>
          </div>
        </div>
      </div>
    </div>
  );
}
